<template>
  <div v-if="parentName !== 'ModemTabLayout'">
    <v-row no-gutters>
      <v-text-field
          label="Genişlik"
          v-model="currentItem['genislik']"
          @input="svgDimen"
      />
    </v-row>

    <v-row no-gutters>
      <v-autocomplete
          label="İkon Seç"
          v-model="currentItem['selected_icon']"
          @input="changeIcon"
          item-text="text"
          item-value="id"
          :items="icons"
      />
    </v-row>

    <v-row no-gutters>
      <v-col class="col-6 px-1">
        <v-text-field
            type="number"
            @input="changeLabelSize"
            label="Etiket Yazı Büyüklüğü"
            v-model="currentItem['etiketFontSize']"
        />
      </v-col>
      <v-col class="col-6 px-1">
        <v-text-field
            @input="changeLabel"
            label="Etiket Label"
            v-model="currentItem['elementLabel']"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-autocomplete
          label="Animasyon Tipi (0 - 1 şeklinde düşünülmeli)"
          :items="animationTypes"
          v-model="currentItem['animation_type']"
      />
    </v-row>

    <v-row no-gutters>
      <v-autocomplete
          v-model="currentItem['bagli_alan']"
          item-text="Text"
          item-value="Id"
          label="Bağlı Alan"
          :items="bagliAlanItems"
      />
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  changeSvgDimension,
  findBinaryValue
} from "@/components/ModemLayoutWizard/ModemLayoutSettings/svgComponentUtils/svgUtilFunctions";
import store from "@/vuex_store/store_wrapper";

export default {
  name: "boxEtiketStd",
  props: {
    currentItem: {
      type: Object,
      required: false
    },
    modemID: {
      type: [Array, Number],
      required: false
    },
    //from modem tab layout
    parentName: String,
    svgItemObject: {
      type: Object,
      required: false
    },
    listSetup: Object,
    dataProperty: Object
  },
  data() {
    return {
      icons: [
        {
          id: 0,
          text: "Servis Dışı",
          path:
              "M100 110C81.198 110 66 125.198 66 144C66 162.802 81.198 178 100 178C118.802 178 134 162.802 134 144C134 125.198 118.802 110 100 110ZM117 156.206L112.206 161L100 148.794L87.794 161L83 156.206L95.206 144L83 131.794L87.794 127L100 139.206L112.206 127L117 131.794L104.794 144L117 156.206Z"
        },
        {
          id: 1,
          text: "Şebeke",
          path:
              "M123.791 135.265C123.65 135.02 123.447 134.817 123.201 134.675C122.955 134.533 122.675 134.459 122.391 134.459H101.308L104.843 107.767C104.881 107.409 104.796 107.05 104.602 106.746C104.408 106.442 104.117 106.212 103.774 106.092C103.432 105.972 103.058 105.969 102.714 106.085C102.37 106.2 102.075 106.426 101.877 106.727L76.2384 151.122C76.0885 151.363 76.0063 151.639 76.0003 151.922C75.9944 152.205 76.0649 152.484 76.2046 152.731C76.3442 152.978 76.548 153.184 76.7949 153.327C77.0418 153.47 77.3229 153.546 77.6091 153.546H98.3763L95.5752 180.278C95.5477 180.634 95.6415 180.989 95.8415 181.286C96.0416 181.583 96.3365 181.806 96.6793 181.918C97.0221 182.031 97.3932 182.027 97.7334 181.907C98.0736 181.787 98.3635 181.558 98.5569 181.257L123.771 136.866C123.918 136.625 123.996 136.35 124 136.068C124.003 135.787 123.931 135.51 123.791 135.265Z"
        },
        {
          id: 2,
          text: "Revizyon",
          path:
              "M137.761 139.781C137.641 138.713 136.395 137.909 135.318 137.909C131.836 137.909 128.746 135.866 127.45 132.703C126.127 129.464 126.98 125.687 129.575 123.307C130.392 122.56 130.491 121.309 129.806 120.441C128.024 118.177 125.998 116.133 123.786 114.361C122.921 113.667 121.649 113.763 120.898 114.594C118.633 117.103 114.565 118.035 111.42 116.723C108.15 115.347 106.085 112.032 106.288 108.473C106.355 107.355 105.537 106.383 104.423 106.253C101.584 105.924 98.72 105.915 95.873 106.231C94.7726 106.352 93.9555 107.301 93.992 108.406C94.1152 111.929 92.0275 115.186 88.7883 116.513C85.682 117.782 81.6416 116.857 79.3813 114.37C78.6342 113.551 77.3849 113.451 76.5135 114.13C74.2365 115.917 72.1655 117.963 70.3663 120.208C69.6652 121.08 69.7688 122.345 70.5928 123.095C73.2383 125.491 74.0912 129.3 72.7177 132.577C71.4062 135.701 68.1625 137.713 64.4494 137.713C63.2445 137.674 62.387 138.484 62.2539 139.58C61.9199 142.434 61.9163 145.343 62.2378 148.22C62.3577 149.293 63.6406 150.09 64.7298 150.09C68.0396 150.006 71.2153 152.053 72.5494 155.296C73.8769 158.535 73.0223 162.311 70.4238 164.694C69.611 165.441 69.5071 166.689 70.1934 167.556C71.9581 169.805 73.9854 171.851 76.2039 173.638C77.0749 174.34 78.3417 174.241 79.0966 173.409C81.3704 170.895 85.4385 169.964 88.5698 171.279C91.85 172.651 93.9134 175.966 93.7119 179.526C93.6459 180.644 94.4656 181.619 95.5762 181.746C97.0289 181.916 98.4893 182 99.9542 182C101.344 182 102.735 181.924 104.126 181.769C105.227 181.648 106.043 180.698 106.006 179.593C105.879 176.071 107.971 172.814 111.206 171.49C114.333 170.212 118.356 171.147 120.617 173.63C121.368 174.447 122.61 174.547 123.485 173.87C125.758 172.088 127.825 170.043 129.632 167.792C130.334 166.921 130.235 165.654 129.406 164.903C126.761 162.509 125.904 158.698 127.277 155.425C128.568 152.343 131.691 150.274 135.05 150.274L135.52 150.286C136.611 150.374 137.613 149.535 137.745 148.422C138.08 145.566 138.084 142.659 137.761 139.781ZM99.9999 165.908C87.9003 165.908 78.0922 156.1 78.0922 144C78.0922 131.901 87.9006 122.093 99.9999 122.093C112.099 122.093 121.908 131.901 121.908 144C121.908 148.107 120.775 151.948 118.809 155.233L109.216 145.64C109.91 144.003 110.277 142.228 110.277 140.396C110.277 136.808 108.88 133.436 106.343 130.899C103.806 128.363 100.434 126.966 96.8469 126.966C95.6498 126.966 94.4584 127.125 93.3057 127.439C92.8008 127.577 92.388 127.993 92.2536 128.499C92.1162 129.016 92.271 129.546 92.6753 129.951C92.6753 129.951 97.4112 134.723 98.9957 136.307C99.1617 136.473 99.1614 136.869 99.1381 137.012L99.1233 137.116C98.9635 138.858 98.6556 140.949 98.4015 141.753C98.3673 141.787 98.3351 141.815 98.3003 141.85C98.2638 141.886 98.2303 141.922 98.1951 141.958C97.381 142.219 95.2577 142.531 93.4881 142.689L93.4884 142.68L93.4089 142.7C93.3948 142.701 93.3685 142.703 93.3336 142.703C93.1423 142.703 92.861 142.65 92.6053 142.394C90.956 140.745 86.4058 136.227 86.4058 136.227C85.9975 135.82 85.5788 135.735 85.2998 135.735C84.6493 135.735 84.0669 136.205 83.8835 136.879C82.6309 141.514 83.9588 146.5 87.3497 149.892C89.8868 152.428 93.2597 153.825 96.8472 153.825C98.6792 153.825 100.454 153.459 102.092 152.764L111.789 162.461C108.384 164.639 104.341 165.908 99.9999 165.908Z"
        },
        {
          id: 3,
          text: "Kat Kapı",
          path:
              "M112.091 106.053C113.098 105.875 114.133 106.151 114.917 106.806C115.701 107.461 116.154 108.427 116.154 109.445V112.893V116.338V119.783V168.01V171.455V174.9V177.631V178.345C116.154 179.363 115.701 180.329 114.917 180.984C114.289 181.508 113.5 181.789 112.692 181.789C112.492 181.789 112.291 181.772 112.091 181.737L72.8601 174.847C71.206 174.557 70 173.126 70 171.455V116.339C70 114.668 71.2058 113.237 72.8599 112.947L112.091 106.053ZM98.8462 149.636C99.7575 149.636 100.651 149.269 101.294 148.628C101.938 147.985 102.308 147.099 102.308 146.191C102.308 145.284 101.938 144.398 101.294 143.755C100.651 143.114 99.7575 142.746 98.8462 142.746C97.9345 142.746 97.0438 143.114 96.3976 143.755C95.7538 144.397 95.3846 145.284 95.3846 146.191C95.3846 147.099 95.7538 147.985 96.3976 148.628C97.0439 149.269 97.9347 149.636 98.8462 149.636ZM126.538 112.89C127.457 112.89 128.337 113.253 128.986 113.899C129.635 114.545 130 115.421 130 116.335V171.455C130 173.357 128.45 174.9 126.538 174.9H123.077V171.455V168.01V119.781V116.336V112.891L126.538 112.89H126.538Z"
        },
        {
          id: 4,
          text: "Uyku",
          path:
              "M109 106C115.916 106 122.414 107.9 128 111.13C116.638 117.704 109 129.94 109 144C109 158.06 116.638 170.296 128 176.87C122.414 180.1 115.916 182 109 182C88.024 182 71 164.976 71 144C71 123.024 88.024 106 109 106Z"
        },
        {
          id: 5,
          text: "Alarm",
          path:
              "M119.833 143.329C119.833 149.595 122.579 155.511 127.367 159.558C128.627 160.638 129.333 162.17 129.333 163.792C129.333 166.847 126.847 169.333 123.792 169.333H71.5417C68.4858 169.333 66 166.847 66 163.792C66 162.17 66.7062 160.638 67.938 159.583C72.7545 155.511 75.5 149.595 75.5 143.329V134.5C75.5 123.356 83.7745 114.132 94.5 112.587V109.167C94.5 107.415 95.9186 106 97.6666 106C99.4146 106 100.833 107.415 100.833 109.167V112.587C111.556 114.132 119.833 123.356 119.833 134.5V143.329ZM109.301 172.5C108.199 177.912 103.402 182 97.6667 182C91.9319 182 87.1344 177.912 86.0324 172.5H109.301Z"
        },
        {
          id: 6,
          text: "Isıtıcı",
          path:
              "M110.667 148.838V118.667C110.667 111.671 104.996 106 98 106C91.0044 106 85.3334 111.671 85.3334 118.667V148.838C81.4463 152.317 79 157.373 79 163C79 173.493 87.5067 182 98 182C108.493 182 117 173.493 117 163C117 157.373 114.554 152.317 110.667 148.838ZM98 175.667C91.0044 175.667 85.3334 169.996 85.3334 163C85.3334 159.343 86.8832 155.95 89.5572 153.557L91.6668 151.669V118.667C91.6668 115.169 94.5024 112.333 98.0001 112.333C101.498 112.333 104.334 115.169 104.334 118.667V151.669L106.443 153.557C109.117 155.95 110.667 159.343 110.667 163C110.667 169.996 104.996 175.667 98 175.667ZM101.167 131.333H94.8334V154.041C91.1436 155.345 88.5 158.864 88.5 163C88.5 168.247 92.7533 172.5 98 172.5C103.247 172.5 107.5 168.247 107.5 163C107.5 158.864 104.856 155.345 101.167 154.041V131.333Z"
        },
        {
          id: 7,
          text: "Pompa",
          path:
              "M82.7812 110.453H80.5547C79.325 110.453 78.3281 109.456 78.3281 108.227C78.3281 106.997 79.325 106 80.5547 106H101.336C102.566 106 103.562 106.997 103.562 108.227C103.562 109.456 102.566 110.453 101.336 110.453H99.1094V116.391H82.7812V110.453ZM110.984 120.102C110.984 118.872 109.987 117.875 108.758 117.875C107.528 117.875 106.531 118.872 106.531 120.102V120.844H75.3594V120.102C75.3594 118.872 74.3625 117.875 73.1328 117.875C71.9032 117.875 70.9062 118.872 70.9062 120.102V120.844H70.1641C65.6624 120.844 62 124.506 62 129.008V149.789C62 154.291 65.6624 157.953 70.1641 157.953H70.9062V158.695C70.9062 159.925 71.9032 160.922 73.1328 160.922C74.3625 160.922 75.3594 159.925 75.3594 158.695V157.953H106.531V158.695C106.531 159.925 107.528 160.922 108.758 160.922C109.987 160.922 110.984 159.925 110.984 158.695V157.953H111.727C116.228 157.953 119.891 154.291 119.891 149.789V129.008C119.891 124.506 116.228 120.844 111.727 120.844H110.984V120.102ZM110.984 120.844V157.953H106.531V120.844H110.984ZM75.3594 157.953H70.9062V120.844H75.3594V157.953ZM133.547 134.945H135.773C137.003 134.945 138 135.942 138 137.172V141.625C138 142.855 137.003 143.852 135.773 143.852H133.547V134.945ZM124.344 130.492C126.803 130.492 128.797 132.486 128.797 134.945V143.852C128.797 146.311 126.803 148.305 124.344 148.305V130.492ZM98.3672 150.531H83.5234C82.2938 150.531 81.2969 149.534 81.2969 148.305C81.2969 147.075 82.2938 146.078 83.5234 146.078H98.3672C99.5968 146.078 100.594 147.075 100.594 148.305C100.594 149.534 99.5968 150.531 98.3672 150.531ZM98.3672 141.625H83.5234C82.2938 141.625 81.2969 140.628 81.2969 139.398C81.2969 138.169 82.2938 137.172 83.5234 137.172H98.3672C99.5968 137.172 100.594 138.169 100.594 139.398C100.594 140.628 99.5968 141.625 98.3672 141.625ZM98.3672 132.719H83.5234C82.2938 132.719 81.2969 131.722 81.2969 130.492C81.2969 129.263 82.2938 128.266 83.5234 128.266H98.3672C99.5968 128.266 100.594 129.263 100.594 130.492C100.594 131.722 99.5968 132.719 98.3672 132.719ZM79.7964 168.641L81.8294 162.406H100.061L102.094 168.641H79.7964ZM62 179.773C62 181.003 62.9969 182 64.2266 182H117.664C118.894 182 119.891 181.003 119.891 179.773C119.891 176.084 116.9 173.094 113.211 173.094H68.6797C64.9906 173.094 62 176.084 62 179.773Z"
        },
        {
          id: 9,
          text: "Termik",
          path:
              "M127.984 134.925V110H78.6667V119.917H73V135.234H78.6667V147.675H73V162.992H78.6667V172.909H90.9091V178H96.4418V172.909H100.426V178H106.225V172.909H110.209V178H115.742V172.909H127.984V147.984H120.016V164.94H86.6355V117.969H120.016V134.925H127.984ZM127.984 138.909H120.105V144H127.984V138.909ZM90.6198 160.956V121.953H116.031V160.956H90.6198ZM101.132 146.379L104.102 147.864L108.137 139.794H103.887L105.519 136.53L102.549 135.045L98.5143 143.115H102.764L101.132 146.379Z"
        }
      ],
      etiketValue: 0,
      bagliAlanItems: [],
      unsubscribe: null,
      // 0 - 1 şeklinde düşünülmeli
      animationTypes: [
        "Kırmızı-Yeşil",
        "Yeşil-Kırmızı",
        "Gri-Yeşil",
        "Yeşil-Gri"
      ],
      colors: {
        kirmiziYesil: ["#F34A4A", "#55D278"],
        yesilKirmizi: ["#55D278", "#F34A4A"],
        yesilGri: ["#55D278", "#b0b0b0"],
        griYesil: ["#b0b0b0", "#55D278"]
      }
    };
  },
  computed: {
    ...mapGetters({
      getterSVGScaleInfo: "storeSVGScale/getterSVGScaleInfo"
    }),
    svgDimen: function() {
      return changeSvgDimension(this.currentItem);
    },
    getBaseGroupId: function() {
      if (this.parentName === "ModemTabLayout") {
        return document
            .getElementById(this.svgItemObject["id"])
            .getElementsByTagName("svg")[0];
      } else {
        return document
            .getElementById(this.currentItem["id"])
            .getElementsByTagName("svg")[0];
      }
    },
    getEtiket: function() {
      const svgBase = this.getBaseGroupId;
      return svgBase.querySelector("#box_etiket_label");
    },
    getIcon: function() {
      const svgBase = this.getBaseGroupId;
      const iconBase = svgBase.querySelector("#box_etiket_icon");
      return iconBase.getElementsByTagName("path")[0];
    },
    getBase: function() {
      const svgBase = this.getBaseGroupId;
      const baseG = svgBase.querySelector("#box_etiket_base");
      return baseG.getElementsByTagName("rect")[0];
    }
  },
  beforeDestroy() {
    this.unsubscribe && this.unsubscribe();
  },
  created() {
    this.unsubscribe = store.subscribe(this.storeHandler);
    if (this.parentName !== "ModemTabLayout") {
      this.getBagliAlanInputs();
    }
  },
  mounted() {
    this.parentName === "ModemTabLayout" &&
    this.setScadaData(this.dataProperty["Id"], this.dataProperty["Datas"]);
  },
  methods: {
    storeHandler: function(mutation) {
      const { type, payload } = mutation;
      if (type === "storeSocket/on_socket_message") {
        const { data, command } = JSON.parse(payload.data);
        if (command === "ModemIOList") {
          const { TargetID, Elements } = data;
          const { id } = this.parentName === "ModemLayoutWizard" ? this.currentItem : this.svgItemObject;
          if (id === TargetID) {
            console.log("Modem Inputlar", data);
            this.bagliAlanItems = Object.keys(Elements).map(key => {
              return {
                Text: Elements[key],
                Id: key
              };
            });
          }
        } else if (command === "ProcessData") {
          const { ModemId, Datas } = data;
          //console.log("DATA Pompa Etiket => ", data);
          if (ModemId === this.modemID) {
            this.setScadaData(ModemId, Datas);
          }
        }
      }
    },
    setScadaData: function(ModemId, Datas) {
      if (Object.keys(Datas).length > 0) {
        const { bagli_alan } = this.svgItemObject;
        const [tip, master, bit] = bagli_alan.split("_");
        if (Datas.hasOwnProperty(`${tip}_${master}`)) {
          console.log("Input Box Etiket MasterId Bit", tip, master, bit);
          this.etiketValue = findBinaryValue(Datas[`${tip}_${master}`], bit);
          console.log("Input Box Etiket Value", this.etiketValue);
          this.boxEtiketAnim();
        }
      }
    },
    boxEtiketAnim: function() {
      const { animation_type } = this.svgItemObject;
      switch (animation_type) {
        case "Kırmızı-Yeşil":
          this.kirmiziYesilAnim();
          break;
        case "Yeşil-Kırmızı":
          this.yesilKirmiziAnim();
          break;
      }
    },
    kirmiziYesilAnim: function() {
      if (this.etiketValue === "0") {
        this.getBase.setAttribute(
            "style",
            `fill: ${this.colors.kirmiziYesil[0]}; transition: .2s ease-in-out;`
        );
      } else if (this.etiketValue === "1") {
        this.getBase.setAttribute(
            "style",
            `fill: ${this.colors.kirmiziYesil[1]}; transition: .2s ease-in-out;`
        );
      }
    },
    yesilKirmiziAnim: function() {
      if (this.etiketValue === "0") {
        this.getBase.setAttribute(
            "style",
            `fill: ${this.colors.yesilKirmizi[0]}; transition: .2s ease-in-out;`
        );
      } else if (this.etiketValue === "1") {
        this.getBase.setAttribute(
            "style",
            `fill: ${this.colors.yesilKirmizi[1]}; transition: .2s ease-in-out;`
        );
      }
    },
    changeIcon: function(v) {
      const iconPath = this.icons.filter(a => a.id === v)[0].path;
      this.getIcon.setAttribute("d", iconPath);
    },
    changeLabel: function() {
      const tspan = this.getEtiket.getElementsByTagName("tspan")[0];
      tspan.innerHTML = this.currentItem["elementLabel"];
    },
    changeLabelSize: function() {
      this.getEtiket.setAttribute(
          "font-size",
          String(this.currentItem["etiketFontSize"])
      );
    },
    getBagliAlanInputs: function() {
      let getModemIOList = {
        type: "getModemIOList",
        payload: {
          TargetID: this.currentItem["id"],
          ModemId: parseInt(this.modemID[0]),
          Secim: "1"
        }
      };
      this.sendMessageToWS(getModemIOList);
    }
  }
};
</script>

<style scoped></style>
